import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';

const [requiredSwitchProp, ...requiredExtraProps] = requiredProps;

export const props = () => [
    ...ableProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'seletedPlaceholder',
        label: '选择后占位文字',
        type: 'string',
    },
    requiredSwitchProp,
    {
        key: 'showNoResultOption',
        label: '没有想选择用户',
        type: 'boolean',
    },
    ...requiredExtraProps,
    ...validatorProps,
];

export const init = () => ({
    ...ablePropsInit,
    placeholder: '请选择',
    seletedPlaceholder: '重新选择',
    ...requiredPropsInit,
    showNoResultOption: true,
    ...validatorPropsInit,
});

export const name = '快手账号选择器';

export const component = 'mobile-general-form-user-select';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];
